import React from "react";
import { ContainerModal } from "./ConfirmationModalStyled";
import Boton from "../../common/Boton";
var ConfirmationModal = function (_a) {
    var action = _a.action, closeModal = _a.closeModal;
    return (React.createElement(ContainerModal, null,
        React.createElement(Boton, { texto: "Cancelar", variant: "outline", handleOnClick: closeModal }),
        React.createElement(Boton, { texto: "Confirmar", handleOnClick: action })));
};
export default ConfirmationModal;
